import React from 'react';
import SvgIcon from 'core/icons/SvgIcon';
import { TranslateHTML, Translate } from 'core/translate';
import GridCard, {
  GridCardPrimarySection,
  GridCardSecondarySection,
} from '../../../components/cards/gridCard/GridCard';

import {
  PrimaryButton,
  ButtonText,
} from '../../../../core/controls/button/Button';
import Date from '../../../common/intl/Date';
import Time from '../../../common/intl/Time';
import PriceWithDisclaimer from '../../config/priceWithDisclaimer/PriceWithDisclaimer';
import Currency from '../../../common/intl/Currency';
import { LoadingCard } from '../../../common/loading/LoadingComponents';

const SavedBuildCard = ({
  isLoading,
  build,
  onRemoveBuild,
  onViewDetails,
  analyticsKey,
}) => {
  const {
    key,
    savedDate,
    year,
    brand,
    driveType,
    trim,
    engineDescription,
    transmissionDescription,
    interiorColorDescription,
    exteriorColorDescription,
    image,
    bodyStyleTitle,
    formattedConfig,
    netPriceDisclaimer,
    totalIncludedIncentives,
    netPrice,
    isValid,
    isUnknownPrice,
  } = build;

  const DateTime = ({ dateTime }) => (
    <>
      <Date value={dateTime}></Date>
      <Translate value="saved.builds.saved.build.at.v3" />
      <Time value={dateTime}></Time>
    </>
  );

  return (
    <>
      {isLoading ? (
        <LoadingCard type="config-card" />
      ) : (
        <>
          {isValid ? (
            <GridCard>
              <img
                className="saved_build__vehicle-image"
                src={image}
                alt={bodyStyleTitle}
              />
              <GridCardPrimarySection>
                <TranslateHTML
                  as="div"
                  className="saved_build__vehicle-title"
                  value="saved.builds.vehicle.name.v3"
                  year={year}
                  brand={brand}
                  bodyStyleTitle={bodyStyleTitle}
                  formattedConfig={formattedConfig}
                  trim={trim}
                  driveType={driveType}
                />
                <div className="saved_build__vehicle-style">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: engineDescription,
                    }}
                    className="saved_build__vehicle-style-line"
                  />
                  <div
                    dangerouslySetInnerHTML={{
                      __html: transmissionDescription,
                    }}
                    className="saved_build__vehicle-style-line"
                  />
                  <div className="saved_build__vehicle-color">
                    <TranslateHTML
                      as="span"
                      className="saved_build__color-label"
                      value="saved.builds.exterior.v3"
                    />
                    <div className="saved_build__color-value">
                      {exteriorColorDescription}
                    </div>
                  </div>
                  <div className="saved_build__vehicle-color">
                    <TranslateHTML
                      as="span"
                      className="saved_build__color-label"
                      value="saved.builds.interior.v3"
                    />
                    <div className="saved_build__color-value">
                      {interiorColorDescription}
                    </div>
                  </div>
                </div>
              </GridCardPrimarySection>
              <div className="saved_build__bottom-section">
                <div className="saved_build__pricing-container">
                  <div className="saved_build__net-price-container">
                    {!isUnknownPrice && (
                      <TranslateHTML
                        as="div"
                        className="saved_build__net-price-label"
                        value="saved.builds.net.price.v3"
                      />
                    )}
                    <div className="option__disclaimer">
                      <PriceWithDisclaimer
                        classIdentifier="saved_build"
                        message={netPrice}
                        disclaimer={netPriceDisclaimer}
                        useModal
                      />
                    </div>
                  </div>
                  {totalIncludedIncentives && (
                    <div className="saved_build__cash-allowance">
                      <Translate value="saved.build.includes.v3" />{' '}
                      <Currency value={totalIncludedIncentives} />{' '}
                      <Translate value="saved.build.cash.allowance.v3" />
                    </div>
                  )}
                </div>
                <GridCardSecondarySection className="saved-build__options-container">
                  <>
                    <div className="saved-build__date">
                      <span className="saved-build__date-label">
                        <Translate value="saved.builds.saved.v3" />
                      </span>
                      <DateTime dateTime={savedDate} />
                    </div>
                    <div className="saved-build__options">
                      <PrimaryButton
                        className="stat-button-link saved-build__options__button--details"
                        data-dtm={analyticsKey}
                        onClick={() => {
                          onViewDetails(build);
                        }}>
                        <ButtonText>
                          <Translate value="view.details.v3" />
                        </ButtonText>
                      </PrimaryButton>
                      <button
                        data-dtm={analyticsKey}
                        className="save-build__remove-option stat-button-link"
                        onClick={() => {
                          onRemoveBuild(key);
                        }}>
                        <SvgIcon
                          className="button__icon--left save-build__remove-icon"
                          name="remove"
                        />
                        <TranslateHTML
                          className="saved-build__remove-label"
                          value="remove.option"
                        />
                      </button>
                    </div>
                  </>
                </GridCardSecondarySection>
              </div>
            </GridCard>
          ) : null}
        </>
      )}
    </>
  );
};

export default SavedBuildCard;
